/** A new mask on the result preview should be sent with that result image. */
export function maskEditTargetsResult(hasMask, resultImageUrl, stageKey) {
  return Boolean(hasMask && resultImageUrl && stageKey === "preview");
}
